enum ChatJobStatus {
  NEW = 'NEW',
  READ = 'READ',
  OWNED = 'OWNED',
  RESOLVED = 'RESOLVED'
}

export default ChatJobStatus;